module.exports = __webpack_public_path__ + "files/f99790d6a9f80c469fd03e4c8e265ed5.png";